export const BASE_RESERVE = 0.5;
export const BASE_RESERVE_MIN_COUNT = 2;